import { message } from 'antd';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

import { sanitizeFilename } from './index';

const PDF_PADDING_PX = 40;

const pxToMm = (px: number) => (px * 25.4) / 96;

export interface ExportPdfOptions {
  contentRef: React.RefObject<HTMLElement>;
  fileName: string;
  setIsExporting: (isExporting: boolean) => void;
}

export const exportContentToPdf = async ({ contentRef, fileName, setIsExporting }: ExportPdfOptions): Promise<void> => {
  if (!contentRef.current) return;

  setIsExporting(true);

  await new Promise((resolve) => setTimeout(resolve, 50));

  try {
    const canvas = await html2canvas(contentRef.current, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff',
    });

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    });

    const pageWidth = 210;
    const pageHeight = 297;
    const pad = pxToMm(PDF_PADDING_PX);
    const innerW = pageWidth - 2 * pad;
    const innerH = pageHeight - 2 * pad;

    const imgWidth = innerW;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    if (imgHeight <= innerH) {
      pdf.addImage(imgData, 'PNG', pad, pad, imgWidth, imgHeight);
    } else {
      let position = pad;
      let heightLeft = imgHeight;

      while (heightLeft > 0) {
        pdf.addImage(imgData, 'PNG', pad, position, imgWidth, imgHeight);
        heightLeft -= innerH;
        if (heightLeft > 0) {
          pdf.addPage();
          position -= innerH;
        }
      }
    }

    pdf.save(`${sanitizeFilename(fileName)}.pdf`);

    message.success('PDF를 내보냈습니다.');
  } catch (error) {
    console.error('PDF 생성 실패:', error);
    message.error('PDF 내보내기에 실패했습니다.');
  } finally {
    setIsExporting(false);
  }
};
